// send event to keep Analytics aware
var to_consider_inactive = 60; // seconds
var between_events = 20; // seconds
var timeout;
var interval;
var counter;
const onUserActivity = () => {
    // console.log('onUserActivity')
    counter = 0
}
window.addEventListener('scroll', onUserActivity)
window.addEventListener('click', onUserActivity)
onUserActivity()
var interval = setInterval( function() {
    counter++;
    var since_last_interaction = counter * between_events;
    if(since_last_interaction <= to_consider_inactive) {
        // ga('event', 'user activity', 'scroll or click', since_last_interaction + ' seconds ago');
        dataLayer.push({ event: 'user activity scroll or click', eventCategory: 'user activity', eventAction: 'scroll or click', eventLabel: since_last_interaction + ' seconds ago'});
    }
}, between_events * 1000);
